const HIGH_QUALITY_VIDEO_ID = '31a913e5-238e-4903-b6ab-20932474a57d'
const STANDARD_QUALITY_VIDEO_ID = '959fb6bf-9d3f-4036-936d-38b6a9021d1c'
const TRAILER_VIDEO_ID = 'd8d407b9-d888-474c-a006-bb430141c9db'
const INTRO_VIDEO_ID = 'df056ce1-95ab-4cb7-81be-f17d8ae71997'

export const browseContent = {
  audioLanguages: 'English, German, French, Spanish, Portuguese, and more to come.',
  accordionItems: [
    {
      title: 'Spiritual Meal Planner',
      content:
        "Introducing: The Spiritual Meal Planner\n\nCreated by {{brand_lettermark}}, the Spiritual Meal Planner is a first-of-its-kind tool to integrate your mind, body, and spirit through food.\n\nThe foundation of the Spiritual Meal Planner is a personalization quiz. That's right, custom recipes, deals, tips, and automated grocery lists are generated based on you: your appetite, available time, kitchen supplies, household size, allergies, and more.\n\nPlus, unlimited access to caring coaches who are committed to inspiring and supporting your ethical lifestyle.",
      link: {
        text: 'Explore the Spiritual Meal Planner',
        url: 'https://spiritualmealplanner.com',
      },
    },
    {
      title: 'Join Our Community',
      content:
        "Join {{brand_lettermark}}'s free community platform—a space where you can connect with others and get rewarded for your activism.\n\nWhether you are a curious viewer, ready to take action, or even a bit skeptical, we encourage you to join.\n\nThose who Pay it Forward $200+ one-time or $10+ monthly receive additional exclusive perks like early access, events, and private discussion channels.",
      link: {
        text: 'Join The {{brand_lettermark}} Community',
        url: 'https://christspiracy.circle.so',
      },
    },
  ],
  mainContent: {
    film: {
      title: '{{brand_name}}',
      slug: 'hd-film',
      videoId: HIGH_QUALITY_VIDEO_ID,
      standardVideoId: STANDARD_QUALITY_VIDEO_ID,
      description:
        'Two daring filmmakers embark on a global quest sparked by the not-so-simple question "is there a spiritual way to kill an animal", and along the way discover the biggest coverup in the last 2000 years.',
      duration: 100,
      image: '{{brand_site_thumbnail_path}}',
      levelOfAccess: 'standard' as const,
      directors: 'Kameron Waters & Kip Andersen',
      year: 2024,
      genre: 'Documentary',
    },
    intro: {
      title: '{{brand_name}} Introduction',
      slug: 'intro',
      videoId: INTRO_VIDEO_ID,
      description: 'A short introduction before you watch {{brand_name}}.',
      embedUrl: `https://player.mediadelivery.net/embed/327014/${INTRO_VIDEO_ID}?autoplay=true&loop=false&muted=false&preload=true&responsive=true`,
      image: '{{brand_site_thumbnail_path}}',
      levelOfAccess: 'free' as const,
    },
    trailer: {
      title: '{{brand_name}} Trailer',
      slug: 'trailer',
      videoId: TRAILER_VIDEO_ID,
      description: 'Watch the official {{brand_name}} trailer.',
      embedUrl: 'https://www.youtube.com/embed/17lo7W_ulPM?autoplay=1&color=white&rel=0',
      image: '{{brand_site_thumbnail_path}}',
      levelOfAccess: 'free' as const,
    },
  },
  extendedInterviews: [
    {
      title: 'Michael Beckwith Extended Interview',
      slug: 'michael-beckwith',
      description:
        'Michael Beckwith uncovers human history and spirituality as it relates to animal ethics.',
      duration: 52,
      videoId: '3558216b-20c4-4696-9540-e891d91d7c85',
      image: '/images/thumbnails/michael-beckwith.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:47:39.208Z',
    },
    {
      title: 'Acharya Prashant Extended Interview',
      slug: 'acharya-prashant',
      description:
        'Acharya Prashant teaches us about the connection between Hinduism and animal ethics, along with other spiritual traditions.',
      duration: 45,
      videoId: 'c8a1d9fb-d84f-4439-bfd4-77b5473fdda8',
      image: '/images/thumbnails/acharya-prashant.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:50:15.652Z',
    },
    {
      title: 'Jim Mason Extended Interview',
      slug: 'jim-mason',
      description:
        'Jim Mason reveals the turning point for animal domestication, and the far-reaching implications today.',
      duration: 50,
      videoId: '43c5dbac-8c4a-4380-b9d1-8b1f24974859',
      image: '/images/thumbnails/jim-mason.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:51:12.800Z',
    },
    {
      title: 'Guru Singh Extended Interview',
      slug: 'guru-singh',
      description:
        'Guru Singh invites us to consider how we can live more compassionately, in alignment with our religious and spiritual values.',
      duration: 39,
      videoId: '1e62785e-b526-4cb8-ae3f-2976c3de36bb',
      image: '/images/thumbnails/guru-singh.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:51:53.312Z',
    },
    {
      title: 'Carol Adams Extended Interview (Part One)',
      slug: 'carol-adams',
      description:
        'Listen as Carol Adams dives deeper into the relationship between patriarchal values and eating meat.',
      duration: 37,
      videoId: 'c99eff88-192d-49d4-a43f-2c330133702d',
      image: '/images/thumbnails/carol-adams-part-one.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:52:37.701Z',
    },
    {
      title: 'Andrew Linzey Extended Interview (Part One)',
      slug: 'andrew-linzey',
      description: 'Join Andrew Linzey as he discusses the theology of animal ethics.',
      duration: 28,
      videoId: 'de63aa78-43f3-4ce2-9b11-a7a5d19da776',
      image: '/images/thumbnails/andrew-linzey-part-one.webp',
      levelOfAccess: 'premium' as const,
      featured: true,
      publishedAt: '2024-09-27T15:53:20.410Z',
    },
    {
      title: "Melanie Joy's Extended Interview",
      slug: 'melanie-joy',
      description: 'Listen as Melanie Joy uncovers the phenomenon of carnism.',
      duration: 34,
      videoId: 'a6f6a7ce-6065-41b7-b74e-ec5d9ca10538',
      image: '/images/thumbnails/melanie-joy.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-10-30T18:31:27.849Z',
    },
    {
      title: 'Dr. James Tabor Extended Interview',
      slug: 'james-tabor',
      description:
        'Dr. James Tabor, scholar of Early Christianity, reveals the truth about the original Nazarene movements stance on animals.',
      duration: 114,
      videoId: 'acdd76b4-aaa5-498f-8fab-00a760d83b90',
      image: '/images/thumbnails/james-tabor.webp',
      levelOfAccess: 'premium' as const,
      featured: false,
      publishedAt: '2024-09-27T15:54:10.000Z',
    },
  ],
}

export type BrowsePageContent = typeof browseContent
export type MainContent = typeof browseContent.mainContent
export type ExtendedInterviewItem = (typeof browseContent.extendedInterviews)[number]
